import get from 'lodash/get';

export const getUserCountry = (state) => get(state, 'auth.signUp.userCountry');
export const getIsCodeRequested = (state) => get(state, 'auth.signUp.phoneVerification.requested');
export const getIsPhoneVerified = (state) => get(state, 'auth.signUp.phoneVerification.verified');
export const getPhoneVerificationToken = (state) =>
  get(state, 'auth.signUp.phoneVerification.verificationToken');
export const getPhoneVerificationFormError = (state) => get(state, 'form.SIGNUP_FORM.error');
